import React from "react";
import FormTextField from "../form/redux-form/FormTextField";
import PropTypes from "prop-types";
import { Field, Form } from "react-final-form";
import { Button } from "@material-ui/core";

const validation = (values) => {
  const errors = {};

  if (!values.beaconNumber) {
    errors.beaconNumber = "Nie podano numeru beacon";
  }

  return errors;
};
const AddBeaconForm = ({ handleSubmit, submitting, onCancel }) => {
  return (
    <Form
      onSubmit={handleSubmit}
      validate={validation}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <div>
              <Field
                name="beaconNumber"
                type="text"
                label="Numer beacon"
                id="beaconNumber"
                component={FormTextField}
                fullWidth
                hiddenErrors
              />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button onClick={onCancel} disabled={submitting}>
              Anuluj
            </Button>
            <Button type="submit" disabled={submitting}>
              Zapisz
            </Button>
          </div>
        </form>
      )}
    />
  );
};

AddBeaconForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

export default AddBeaconForm;
